/** @format */

import { useEffect, useContext } from "react";
import { Context } from "../../stores/Provider";
import { Container } from "../../components/layouts/Container";
import useNavigateByAgent from "../../hooks/useNavigateByAgentHooks";

const OldUserRegister = () => {
  const { navigateByAgent } = useNavigateByAgent();
  const { dispatch } = useContext(Context);
  useEffect(() => {
    dispatch({
      type: "set-context-data",
      payload: {
        agentPath: "/ocnk",
      },
    });
    navigateByAgent("/user_register?agent_master_id=1");
  }, [dispatch, navigateByAgent]);

  useEffect(() => {
    navigateByAgent("/user_register?agent_master_id=1");
  }, [navigateByAgent]);

  return <Container></Container>;
};

export default OldUserRegister;
